import { DIFFICULTIES } from '../data/copy.js';

/**
 * World top-20 overlay for one song, with difficulty tabs.
 * Shared by the catalog ("TOP ✦" on each tile) and the rankings screen.
 */
export default class LeaderboardOverlay {
  constructor({ auth }) {
    this.auth = auth;
    this.song = null;
    this.difficulty = 'normal';

    this.root = document.getElementById('lb-overlay');
    document.getElementById('btn-lb-close')?.addEventListener('click', () => this.close());
    this.root?.addEventListener('click', (event) => {
      if (event.target === this.root) this.close();
    });
  }

  open(song, difficulty = 'normal') {
    this.song = song;
    this.difficulty = difficulty;
    this.root?.classList.remove('hidden');
    const title = document.getElementById('lb-title');
    const subtitle = document.getElementById('lb-subtitle');
    if (title) title.textContent = String(song.title || '').toUpperCase();
    if (subtitle) subtitle.textContent = String(song.artist || '').toUpperCase();
    this._renderTabs();
    this._load();
  }

  close() {
    this.song = null;
    this.root?.classList.add('hidden');
  }

  _renderTabs() {
    const tabs = document.getElementById('lb-difficulty-tabs');
    if (!tabs) return;
    tabs.textContent = '';
    for (const { id, label } of DIFFICULTIES) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'difficulty-switch__option';
      button.classList.toggle('is-active', id === this.difficulty);
      button.textContent = label;
      button.addEventListener('click', () => {
        this.difficulty = id;
        this._renderTabs();
        this._load();
      });
      tabs.appendChild(button);
    }
  }

  async _load() {
    const list = document.getElementById('lb-list');
    const empty = document.getElementById('lb-empty');
    const meEl = document.getElementById('lb-me');
    if (!list || !this.song) return;

    const requested = `${this.song.id}|${this.difficulty}`;
    list.textContent = '';
    empty?.classList.add('hidden');
    if (meEl) meEl.textContent = 'CHARGEMENT…';

    const data = await this.auth?.getLeaderboard(this.song.id, this.difficulty);
    // Ignore stale responses (user switched tab/song meanwhile).
    if (!this.song || `${this.song.id}|${this.difficulty}` !== requested) return;

    if (!data) {
      if (meEl) meEl.textContent = 'CLASSEMENT INDISPONIBLE — SERVEUR INJOIGNABLE.';
      return;
    }

    if (!data.entries.length) {
      empty?.classList.remove('hidden');
    }
    for (const entry of data.entries) {
      const li = document.createElement('li');
      li.className = 'lb-list__row';
      if (this.auth?.user && entry.username === this.auth.user.username) li.classList.add('is-me');

      const rank = document.createElement('span');
      rank.className = 'lb-list__rank';
      rank.textContent = `#${entry.rank}`;

      const name = document.createElement('span');
      name.className = 'lb-list__name';
      name.textContent = entry.username;

      const grade = document.createElement('span');
      grade.className = 'lb-list__grade';
      grade.textContent = entry.grade;

      const score = document.createElement('span');
      score.className = 'lb-list__score';
      score.textContent = entry.score.toLocaleString('fr-FR');

      li.append(rank, name, grade, score);
      list.appendChild(li);
    }

    if (meEl) {
      if (data.me && data.me.eligible === false) {
        meEl.textContent = `TOI · ${Number(data.me.score).toLocaleString('fr-FR')} PTS — VALIDE TON EMAIL POUR LE CLASSEMENT PUBLIC`;
      } else {
        meEl.textContent = data.me
          ? `TOI · #${data.me.rank} · ${Number(data.me.score).toLocaleString('fr-FR')} PTS`
          : 'PAS ENCORE DE SCORE SUR CE MORCEAU.';
      }
    }
  }
}
